import React, { useEffect } from "react";
import { Form, FormElement } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import AlertBox from "../../../components/common/AlertBox";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllContraRegisterReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearContraRegisterReportList } from "../reportsSlice";
import { formatIndianNumber } from "../../../_helper/helper";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { sumBy } from "lodash";

const ContraRegisterReportNew: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("contraregisterreportState") || "{}"
  );
  const initialValues = JSON.parse(JSON.stringify(state.initialValues));
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
   
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .salesmanwisereport-print-break{
          page-break-before: always;
          }
      }
     
    `;
    document.head.appendChild(style);
  };

  const ContraRegisterReportList = useAppSelector(
    (state) => state.reports.ContraRegisterReportList
  );
  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      from_date: state?.from_date,
      to_date: state?.to_date,
    };
    const res = await dispatch(getAllContraRegisterReport(payload));

    setPrintStyles();
    if (res.meta.requestStatus === "fulfilled") {
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("contraregisterreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearContraRegisterReportList());
    };
  }, []);

  // const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
  //   return formRenderProps.valueGetter("filter_columns")?.includes(key);
  // };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {ContraRegisterReportList && ContraRegisterReportList.length ? (
        <Form
          initialValues={initialValues}
          render={() => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  {/* <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h5 className="m-0 text-center w-100">
                      Contra Register Report
                      <>
                        <p style={{ fontSize: 16 }}>
                          For Period :-
                          {state.from_date &&
                            state.to_date &&
                            `( ${moment(state.from_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} )`}
                        </p>
                      </>
                    </Typography.h5>
                  </GridLayoutItem> */}
                  <GridLayoutItem>
                    <ButtonWithLoading
                      buttonStyle={{
                        position: "fixed",
                        right: 0,
                        top: 0,
                        zIndex: 100,
                      }}
                      label={"Print"}
                      className="no-visible-print-btn"
                      type="button"
                      onClick={() => window.print()}
                    />

                    <div style={{ textAlign: "center" }}>
                      <h4
                        style={{
                          margin: 0,
                          textAlign: "center",
                          fontWeight: "900",
                        }}
                      >
                        HARIHAR FOODS PVT LTD.
                      </h4>
                      <p style={{ margin: 0 }}>
                        519/1, PHASE IV, VATVA, GIDC, AHMEDABAD-382445
                      </p>
                      <h6
                        style={{
                          margin: 0,
                          textAlign: "center",
                          fontWeight: "900",
                        }}
                      >
                        Contra Register{" "}
                      </h6>
                      <p style={{ margin: 0 }}>
                        {state.from_date &&
                          state.to_date &&
                          `( ${moment(state.from_date, "YYYY-MM-DD").format(
                            "DD/MM/YYYY"
                          )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                            "DD/MM/YYYY"
                          )} )`}
                      </p>
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <table
                      cellSpacing={1}
                      // cellPadding={2}
                      className={`table contra-register-report-table`}
                      // style={{
                      //   width: "fit-content",
                      // }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                          }}
                        >
                          <th style={{ minWidth: 100 }}>Date</th>

                          <th style={{ minWidth: 300, textAlign: "start" }}>
                            Particulars
                          </th>

                          <th style={{ minWidth: 150 }}>Voucher Type</th>

                          <th style={{ minWidth: 150, textAlign: "end" }}>
                            Voucher No
                          </th>

                          <th style={{ minWidth: 120, textAlign: "end" }}>
                            Debit
                          </th>
                          <th style={{ minWidth: 120, textAlign: "end" }}>
                            Credit
                          </th>
                        </tr>
                      </thead>

                      {/* Table Body */}

                      <tbody>
                        {ContraRegisterReportList.map(
                          (item: any, rowIndex: number) => {
                            return (
                              <>
                                <tr key={rowIndex}>
                                  <td style={{ paddingTop: "10px" }}>
                                    {item?.contra_date}
                                  </td>
                                  <td style={{ paddingTop: "10px" }}>
                                    <strong>{item?.account_name}</strong>{" "}
                                  </td>

                                  <td
                                    style={{ paddingTop: "10px" }}
                                    className="text-center"
                                  >
                                    <strong>{item?.voucher_type}</strong>
                                  </td>

                                  <td
                                    style={{ paddingTop: "10px" }}
                                    className="text-end"
                                  >
                                    {item?.contra_no_string}
                                  </td>
                                  <td
                                    style={{ paddingTop: "10px" }}
                                    className="text-end"
                                  >
                                    <strong>
                                      {formatIndianNumber(
                                        item?.contra_total_amount || 0
                                      )}
                                    </strong>
                                  </td>
                                  <td
                                    style={{ paddingTop: "10px" }}
                                    className="text-end"
                                  ></td>
                                </tr>
                                {item?.contra_register?.map(
                                  (entry: any, innerIndex: number) => (
                                    <tr key={innerIndex}>
                                      <td></td>
                                      <td>{entry?.ledger_name}</td>
                                      <td className="text-center"></td>
                                      <td className="text-center"></td>
                                      <td className="text-end"></td>
                                      <td className="text-end">
                                        <strong>
                                          {formatIndianNumber(
                                            entry?.amount || 0
                                          )}
                                        </strong>
                                      </td>
                                    </tr>
                                  )
                                )}

                                {rowIndex ===
                                  ContraRegisterReportList?.length - 1 && (
                                  <tr
                                    style={{
                                      borderTop: "1px solid grey",
                                      borderBottom: "1px solid grey",
                                    }}
                                  >
                                    <td
                                      colSpan={5}
                                      style={{ padding: "5px 0" }}
                                      className="text-end"
                                    >
                                      <strong> Total : </strong>
                                    </td>
                                    <td
                                      className="text-end"
                                      style={{ padding: "5px 0" }}
                                    >
                                      <strong>
                                        {formatIndianNumber(
                                          sumBy(
                                            ContraRegisterReportList,
                                            "contra_total_amount"
                                          ) || 0
                                        )}
                                      </strong>
                                    </td>
                                  </tr>
                                )}
                              </>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default ContraRegisterReportNew;
